var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-data-editor',{attrs:{"id":_vm.id,"title":"Редактирование типа товара","resource":"goods-types","elements":_vm.elements,"add-message":"Тип товара добавлен","edit-message":"Тип товара изменен"},on:{"change":(payload) => _vm.isChanged = payload}})
}
var staticRenderFns = []

export { render, staticRenderFns }